export { CalendarPanelFooter } from './CalendarPanelFooter';
export * from './CalendarPanelFooter.types';

/** Default options for the Date.toLocaleDateString function call */
export const defaultDateToStringOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};
